import get from 'lodash/get';

import { pairAuthFlows } from 'src/common/constants/auth/oauth';
import { PAIR_AUTH_FLOW, USER_CODE } from 'src/common/constants/queryParams';

export function getPairAuthFlowParam(query) {
  return get(query, PAIR_AUTH_FLOW);
}

export function getUserCodeParam(query) {
  return get(query, USER_CODE);
}

export function hasPairAuthFlowParam(query) {
  return !!getPairAuthFlowParam(query);
}

export function isPairAuthFlowPin(query) {
  const pairAuthFlowParam = getPairAuthFlowParam(query);

  return !!(pairAuthFlowParam && pairAuthFlowParam === pairAuthFlows.pin);
}
